/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppWrap from './components/AppWrap';
import reportWebVitals from './reportWebVitals';
import store from './store';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import { setupInterceptors } from './helpers/interceptor';

const root = ReactDOM.createRoot(document.getElementById('root'));

setupInterceptors();

root.render(
  <Provider store={store}>
    <HashRouter>
      <AppWrap />
    </HashRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
